
import { Component, Prop, Model, Watch } from "vue-property-decorator";
import PortalBaseField from "./PortalBaseField.vue";

@Component
export default class PortalMoneyField extends PortalBaseField {
  @Prop() private labelClass!: string;
  @Prop() private label!: string;
  @Model("change", { type: Number }) readonly data!: number | null;
  @Prop() private md: string | number;
  @Prop() private lg: string | number;
  @Prop() private xl: string | number;
  @Prop() private tooltip: string;
  @Prop() private state: any;
  @Prop() private invalidFeedback: any;
  @Prop() private required: boolean;
  @Prop() private readonly: string;

  localData: number | null = null;

  get formattedValue(): string {
    return this.localData === null || this.localData === undefined
      ? ''
      : this.localData.toFixed(2);
  }

  created() {
    this.localData = this.data;
  }

  @Watch('data')
  onDataChange(value: number | null) {
    this.localData = value;
  }

  @Watch('localData')
  onLocalDataChange(value: number | null) {
    this.$emit('change', this.toNumberOrNull(value));
  }

  private toNumberOrNull(value: any): number | null {
    if (value === null || value === undefined || value === '') return null;
    const n = typeof value === 'number' ? value : parseFloat(String(value).replace(/,/g, ''));
    if (Number.isNaN(n)) return null;
    return Math.round(n * 100) / 100;
  }
}
